// ABOUTME: Context set by HeaderBarActionsMenu so a HeaderBarIconButton renders as an entry of the open menu.
// ABOUTME: Kept in its own file to avoid an import cycle between the menu and the button.

import { createContext } from 'react';

export interface HeaderBarMenuContextValue {
    /** The open menu's list element the actions render their MenuItem into; null while closed. */
    container: HTMLElement | null;
    close: () => void;
}

export const HeaderBarMenuContext = createContext<HeaderBarMenuContextValue | null>(null);
